import Vue from 'vue'
import Meta from 'vue-meta'
import { createRouter } from './router.js'
import NoSsr from './components/no-ssr.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../src/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_head_524a32d2 from 'nuxt_plugin_head_524a32d2' // Source: ./purchase-quote/head.js (mode: 'all')
import nuxt_plugin_plugin0_3cea66be from 'nuxt_plugin_plugin0_3cea66be' // Source: ./purchase-quote/plugin-0.js (mode: 'client')
import nuxt_plugin_plugin1_3ce97e00 from 'nuxt_plugin_plugin1_3ce97e00' // Source: ./purchase-quote/plugin-1.js (mode: 'all')
import nuxt_plugin_plugin2_3ce89542 from 'nuxt_plugin_plugin2_3ce89542' // Source: ./purchase-quote/plugin-2.js (mode: 'all')
import nuxt_plugin_plugin3_3ce7ac84 from 'nuxt_plugin_plugin3_3ce7ac84' // Source: ./purchase-quote/plugin-3.js (mode: 'all')
import nuxt_plugin_plugin4_3ce6c3c6 from 'nuxt_plugin_plugin4_3ce6c3c6' // Source: ./purchase-quote/plugin-4.js (mode: 'server')
import nuxt_plugin_plugin5_3ce5db08 from 'nuxt_plugin_plugin5_3ce5db08' // Source: ./purchase-quote/plugin-5.js (mode: 'client')
import nuxt_plugin_plugin6_3ce4f24a from 'nuxt_plugin_plugin6_3ce4f24a' // Source: ./purchase-quote/plugin-6.js (mode: 'all')
import nuxt_plugin_plugin7_3ce4098c from 'nuxt_plugin_plugin7_3ce4098c' // Source: ./purchase-quote/plugin-7.js (mode: 'all')
import nuxt_plugin_plugin8_3ce320ce from 'nuxt_plugin_plugin8_3ce320ce' // Source: ./purchase-quote/plugin-8.js (mode: 'all')
import nuxt_plugin_plugin9_3ce23810 from 'nuxt_plugin_plugin9_3ce23810' // Source: ./purchase-quote/plugin-9.js (mode: 'all')
import nuxt_plugin_plugin10_4fdce5de from 'nuxt_plugin_plugin10_4fdce5de' // Source: ./purchase-quote/plugin-10.js (mode: 'all')
import nuxt_plugin_plugin11_4fdd5a3d from 'nuxt_plugin_plugin11_4fdd5a3d' // Source: ./purchase-quote/plugin-11.js (mode: 'all')
import nuxt_plugin_plugin12_4fddce9c from 'nuxt_plugin_plugin12_4fddce9c' // Source: ./purchase-quote/plugin-12.js (mode: 'all')
import nuxt_plugin_plugin13_4fde42fb from 'nuxt_plugin_plugin13_4fde42fb' // Source: ./purchase-quote/plugin-13.js (mode: 'all')
import nuxt_plugin_plugin14_4fdeb75a from 'nuxt_plugin_plugin14_4fdeb75a' // Source: ./purchase-quote/plugin-14.js (mode: 'all')
import nuxt_plugin_plugin15_4fdf2bb9 from 'nuxt_plugin_plugin15_4fdf2bb9' // Source: ./purchase-quote/plugin-15.js (mode: 'all')
import nuxt_plugin_plugin16_4fdfa018 from 'nuxt_plugin_plugin16_4fdfa018' // Source: ./purchase-quote/plugin-16.js (mode: 'all')
import nuxt_plugin_plugin17_4fe01477 from 'nuxt_plugin_plugin17_4fe01477' // Source: ./purchase-quote/plugin-17.js (mode: 'all')
import nuxt_plugin_plugin18_4fe088d6 from 'nuxt_plugin_plugin18_4fe088d6' // Source: ./purchase-quote/plugin-18.js (mode: 'all')
import nuxt_plugin_plugin19_4fe0fd35 from 'nuxt_plugin_plugin19_4fe0fd35' // Source: ./purchase-quote/plugin-19.js (mode: 'all')
import nuxt_plugin_plugin20_4feafd5f from 'nuxt_plugin_plugin20_4feafd5f' // Source: ./purchase-quote/plugin-20.js (mode: 'all')
import nuxt_plugin_plugin21_4feb71be from 'nuxt_plugin_plugin21_4feb71be' // Source: ./purchase-quote/plugin-21.js (mode: 'all')
import nuxt_plugin_plugin22_4febe61d from 'nuxt_plugin_plugin22_4febe61d' // Source: ./purchase-quote/plugin-22.js (mode: 'all')
import nuxt_plugin_plugin23_4fec5a7c from 'nuxt_plugin_plugin23_4fec5a7c' // Source: ./purchase-quote/plugin-23.js (mode: 'all')
import nuxt_plugin_plugin24_4feccedb from 'nuxt_plugin_plugin24_4feccedb' // Source: ./purchase-quote/plugin-24.js (mode: 'all')

// Component: <NoSsr>
Vue.component(NoSsr.name, NoSsr)

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>`
Vue.component(Nuxt.name, Nuxt)

// vue-meta configuration
Vue.use(Meta, {
  keyName: 'head', // the component option name that vue-meta looks for meta info on.
  attribute: 'data-n-head', // the attribute name vue-meta adds to the tags it observes
  ssrAttribute: 'data-n-head-ssr', // the attribute name that lets vue-meta know that meta info has already been server-rendered
  tagIDKeyName: 'hid' // the property name that vue-meta uses to determine whether to overwrite or append a tag
})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    router,
    store,
    nuxt: {
      defaultTransition,
      transitions: [ defaultTransition ],
      setTransitions(transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [ transitions ]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },
      err: null,
      dateErr: null,
      error(err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        const nuxt = this.nuxt || this.$options.nuxt
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) ssrContext.nuxt.error = err
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    store,
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  const inject = function (key, value) {
    if (!key) throw new Error('inject(key, value) has no key provided')
    if (typeof value === 'undefined') throw new Error('inject(key, value) has no value provided')
    key = '$' + key
    // Add into app
    app[key] = value

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) return
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Vue.prototype.hasOwnProperty(key)) {
        Object.defineProperty(Vue.prototype, key, {
          get() {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Plugin execution

  if (typeof nuxt_plugin_head_524a32d2 === 'function') {
    await nuxt_plugin_head_524a32d2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_plugin0_3cea66be === 'function') {
    await nuxt_plugin_plugin0_3cea66be(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin1_3ce97e00 === 'function') {
    await nuxt_plugin_plugin1_3ce97e00(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin2_3ce89542 === 'function') {
    await nuxt_plugin_plugin2_3ce89542(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin3_3ce7ac84 === 'function') {
    await nuxt_plugin_plugin3_3ce7ac84(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_plugin4_3ce6c3c6 === 'function') {
    await nuxt_plugin_plugin4_3ce6c3c6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_plugin5_3ce5db08 === 'function') {
    await nuxt_plugin_plugin5_3ce5db08(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin6_3ce4f24a === 'function') {
    await nuxt_plugin_plugin6_3ce4f24a(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin7_3ce4098c === 'function') {
    await nuxt_plugin_plugin7_3ce4098c(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin8_3ce320ce === 'function') {
    await nuxt_plugin_plugin8_3ce320ce(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin9_3ce23810 === 'function') {
    await nuxt_plugin_plugin9_3ce23810(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin10_4fdce5de === 'function') {
    await nuxt_plugin_plugin10_4fdce5de(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin11_4fdd5a3d === 'function') {
    await nuxt_plugin_plugin11_4fdd5a3d(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin12_4fddce9c === 'function') {
    await nuxt_plugin_plugin12_4fddce9c(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin13_4fde42fb === 'function') {
    await nuxt_plugin_plugin13_4fde42fb(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin14_4fdeb75a === 'function') {
    await nuxt_plugin_plugin14_4fdeb75a(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin15_4fdf2bb9 === 'function') {
    await nuxt_plugin_plugin15_4fdf2bb9(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin16_4fdfa018 === 'function') {
    await nuxt_plugin_plugin16_4fdfa018(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin17_4fe01477 === 'function') {
    await nuxt_plugin_plugin17_4fe01477(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin18_4fe088d6 === 'function') {
    await nuxt_plugin_plugin18_4fe088d6(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin19_4fe0fd35 === 'function') {
    await nuxt_plugin_plugin19_4fe0fd35(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin20_4feafd5f === 'function') {
    await nuxt_plugin_plugin20_4feafd5f(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin21_4feb71be === 'function') {
    await nuxt_plugin_plugin21_4feb71be(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin22_4febe61d === 'function') {
    await nuxt_plugin_plugin22_4febe61d(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin23_4fec5a7c === 'function') {
    await nuxt_plugin_plugin23_4fec5a7c(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin24_4feccedb === 'function') {
    await nuxt_plugin_plugin24_4feccedb(app.context, inject)
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, () => {
        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from, next) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    app,
    store,
    router
  }
}

export { createApp, NuxtError }
